(function(){

	if($("[data-page-about]").isset()){
		var initTl = new TimelineMax({delay: 0.3,repeat:0},0);	
			initTl
				.to($("[data-title]")[0], 1, {opacity: 1})
				.staggerTo($(".about-first__text p"),0.3,{
					opacity: 1
				},0.3)
				.to($(".about-first__img"),0.3,{
					opacity: 1
				})
				.staggerTo($(".about-first__right p"),0.3,{
					opacity: 1
				},0.3)
				.to(".column-two_digit1",0.3,{
					opacity: 1
				});

				// init controller
				var controllerFadeout = new ScrollMagic.Controller();
				$('.js-fade-in').each(function(){
				    var currentRow = this;

				    var tweenRow = new TimelineMax()
				        .from(currentRow, 1,{opacity: 0});

				    var scene = new ScrollMagic.Scene({triggerElement: currentRow, offset: -$(window).height()*0.43})
				        .setTween(tweenRow)
				        .addTo(controllerFadeout);
				});
	}

	
	
	
})()


// WEBPACK FOOTER //
// ./components/page-about.js